import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-upcoming-trainings',
  templateUrl: './upcoming-trainings.component.html',
  styleUrls: ['./upcoming-trainings.component.scss'],
})
export class UpcomingTrainingsComponent  implements OnInit {

  upcomingTrainingForm!: FormGroup;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.upcomingTrainingForm = this.fb.group({
      selectedProgram: [''],
      selectedStatus: [''],
      searchTerm: ['']
    });
  }


  programList: string[] = ['Program 1', 'Program 2']; 

trainingPrograms = [
  {
    trainingType: 'LMS',
    title: 'Problem Solving',
    code: 'PS001',
    lmsLink: 'link',
    startDate: '1-10-24',
    endDate: '15-10-24',
    category: 'Functional',
    department: 'Sales',
    band: 'A',
    grade: 'Leader',
    programDays: 12,
    budgetCost: 'Rs.300',
    actualCost: 'Rs.350',
    objective: 'Strong',
    
  },
  {
    trainingType: 'Offline',
    title: 'Excel',
    code: 'EX002',
    lmsLink: 'link',
    startDate: '3-10-24',
    endDate: '23-10-24',
    category: 'Behavioral',
    department: 'Accounts',
    band: 'B',
    grade: 'Executive',
    location: 'Mumbai',
    programDays: 13,
    budgetCost: 'Rs.400',
    actualCost: 'Rs.400',
    facultyname:'mr das',
    objective: 'Improve'
  }
];






// Define headers dynamically
tableHeaders = [
  { label: 'Training Type', key: 'trainingType' },
  { label: 'Programme Title', key: 'title' },
  { label: 'Programme Code', key: 'code' },
  { label: 'LMS Link', key: 'lmsLink' },
  { label: 'Start Date', key: 'startDate' },
  { label: 'End Date', key: 'endDate' },
  { label: 'Functional/Behavioral', key: 'category' },
  { label: 'Dept.', key: 'department' },
  { label: 'Band', key: 'band' },
  { label: 'Grade', key: 'grade' },
  { label: 'No. of Program Days', key: 'programDays' },
  { label: 'Budget Cost', key: 'budgetCost' },
  { label: 'Actual Cost', key: 'actualCost' },
  { label: 'Objective', key: 'objective' }
];


}
